import React, { useState, useEffect } from 'react'
import { Panel, Form, Button, Radio, RadioGroup, Row, Col, Message, ControlLabel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getRequiredData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../../src/components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { isEmpty } from 'lodash-es'
import {
  getTerminateProjectFileCoworker,
  saveTerminateProjectFileCoworker,
  updateTerminateProjectFileNameCoworker,
  deleteTerminateProjectFileCoworker,
  downloadTerminateProjectFileCoworker,
  updateEndOfProject,
} from '../../redux/actions/endOfProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'

export default function EndOfProjectWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [closeTypeSelected, setCloseTypeSelected] = useState(_schema?.closeType?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [uploadError, setUploadError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()
  const [isErrorFileList, setIsErrorFileList] = useState(false)

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    if (
      isRequired(formSchema.uploadDocuments?.fileList.validators) &&
      formSchema.uploadDocuments?.fileList.value.length === 0 &&
      closeTypeSelected == 2
    ) {
      let reqData = getRequiredData(formSchema.uploadDocuments?.fileList.validators)
      setIsErrorFileList(reqData.errorMessage)
      return
    }

    let request = {
      projectVersionId: projectId,
      value: data[formSchema.note.name],
      //approveType: isApprove ? data[formSchema.approveType.name] : 0,

      note: data[formSchema.note.name],
      closeType: data[formSchema.closeType.name] || 0,
      refundAmount: data[formSchema.refundAmount.name] || 0,
    }
    setRequest(request)
    console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateEndOfProject(projectId, request)
      console.log('response', response)
      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setIsError(e?.response?.data?.errors?.message)
      } else {
        setIsError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const handleCallUploadFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setUploadError()
    try {
      const response = await saveTerminateProjectFileCoworker(projectId, request)
      setFormSchema((state) => {
        return {
          ...state,
          uploadDocuments: response,
        }
      })
      setUploadError(false)
      setIsErrorFileList(false)
    } catch (e) {
      setUploadError('อัปโหลดไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallDeleteFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setDeleteError(false)
    try {
      const response = await deleteTerminateProjectFileCoworker(projectId, request.id)
      if (response == 200) {
        const res = await getTerminateProjectFileCoworker(projectId)
        setFormSchema((state) => {
          return {
            ...state,
            uploadDocuments: res,
          }
        })
      }
    } catch (e) {
      setDeleteError('ลบไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallRenameFile = async (request) => {
    startLoading()
    setIsLoading(true)
    setRenameError()
    try {
      const response = await updateTerminateProjectFileNameCoworker(projectId, request.id, request)
      setFormSchema((state) => {
        return {
          ...state,
          uploadDocuments: response,
        }
      })
      setRenameError(false)
    } catch (e) {
      setRenameError('แก้ไขชื่อไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    console.log('fileObj ', fileObj)
    try {
      const file = await downloadTerminateProjectFileCoworker(projectId, fileObj.path)
      console.log('file ', file)
      previewFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await downloadTerminateProjectFileCoworker(projectId, fileObj.path)
      downloadFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnClickUpload = (filesData) => {
    if (isEmpty(filesData?.attachFiles)) {
      return
    }
    const formData = new FormData()
    filesData?.attachFiles.forEach((element) => {
      formData.append('files', element.blobFile)
    })
    handleCallUploadFiles(formData)
  }

  const handleOnClickDelete = (fileIndex) => {
    if (!formSchema?.uploadDocuments.fileList?.value?.[fileIndex]?.id) {
      return
    }
    const request = {
      id: formSchema.uploadDocuments.fileList.value[fileIndex].id,
      fileName: formSchema.uploadDocuments.fileList.value[fileIndex].name,
    }
    handleCallDeleteFiles(request)
  }

  const handleOnClickRenameFile = (file, newName) => {
    if (!newName) {
      return
    }
    console.log('file', file)
    const request = {
      id: file.id,
      //name: newName,
      label: newName,
    }

    handleCallRenameFile(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.closeType && (
        <>
          <ErrorMessage error={errors[formSchema.closeType.name]} />
          <Controller
            key={formSchema.closeType.name}
            name={formSchema.closeType.name}
            control={control}
            rules={isValidators(formSchema.closeType.validators)}
            defaultValue={formSchema.closeType.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    setCloseTypeSelected(value)
                  }}
                >
                  {formSchema.closeType?.options?.map((item) => {
                    return (
                      <Radio value={item.value} disabled={!showCommandButton}>
                        {item.label}{' '}
                      </Radio>
                    )
                  })}
                </RadioGroup>
              )
            }}
          />
        </>
      )}

      {closeTypeSelected == 2 && (
        <>
          <ErrorMessage error={errors[formSchema.refundAmount.name]} />
          <Row style={{ marginLeft: '1px' }}>
            {formSchema.refundAmount.label}
            <span>
              {' '}
              {formSchema.refundAmount.preLabel}
              {showCommandButton ? (
                <Controller
                  name={formSchema.refundAmount.name}
                  control={control}
                  defaultValue={formSchema.refundAmount.value || 0}
                  rules={isRequired ? { required: 'กรุณากรอกจำนวนเงิน' } : {}}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className={classNames(
                          'rs-input',
                          errors[formSchema.refundAmount.name] && 'is-error'
                        )}
                        thousandSeparator={true}
                        value={props.value}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                        }}
                        style={{ display: 'unset', width: 120, margin: '0px 15px' }}
                      />
                    )
                  }}
                />
              ) : (
                <b> {budgetFormat(formSchema.refundAmount.value)} </b>
              )}
              {formSchema.refundAmount.postLabel}
            </span>
          </Row>

          {formSchema?.uploadDocuments &&
            (showCommandButton ? (
              <>
                <br />
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.uploadDocuments.fileList.validators) && 'required'
                  )}
                >
                  {formSchema.uploadDocuments.header}
                </ControlLabel>

                {isErrorFileList && <Message showIcon type="error" description={isErrorFileList} />}
                <AttachFilesForm
                  schema={formSchema.uploadDocuments?.fileList}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  onSubmit={handleSubmit(handleOnClickUpload)}
                  onDelete={handleOnClickDelete}
                  onUpdate={handleOnClickRenameFile}
                  onDownload={onDownload}
                  onPreview={onPreview}
                  isChangSeqNo={false}
                  isEditErr={renameError}
                  isUploadErr={uploadError}
                  isDeleteError={deleteError}
                  loading={isLoading}
                />
              </>
            ) : (
              <>
                <br />
                <p>{formSchema.uploadDocuments.header}</p>
                <AttachFilesView
                  schema={formSchema.uploadDocuments?.fileList}
                  onDownload={onDownload}
                  onPreview={onPreview}
                />
              </>
            ))}
        </>
      )}

      {formSchema?.note &&
        (showCommandButton ? (
          <InputForm
            schema={formSchema.note}
            rows={3}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <>
            <p>{formSchema.note.label}</p>
            <p style={{ textIndent: '2.5em' }}>{formSchema.note.value}</p>
          </>
        ))}

      {/* {formSchema.approveType && isApprove && (
        <>
          <br />
          <ErrorMessage error={errors[formSchema.approveType.name]} />
          <Controller
            key={formSchema.approveType.name}
            name={formSchema.approveType.name}
            control={control}
            rules={isValidators(formSchema.approveType.validators)}
            defaultValue={formSchema.approveType.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                >
                  {formSchema.approveType?.options?.map((item) => {
                    return <Radio value={item.value}>{item.label} </Radio>
                  })}
                </RadioGroup>
              )
            }}
          />
        </>
      )} */}

      {showCommandButton && (
        <>
          <hr />

          {isError && <Message showIcon type="error" description={isError} />}

          <Button
            ripple
            // appearance="ghost"
            color="rgb(45, 168, 136)"
            appearance="primary"
            onClick={handleSubmit(onSubmit)}
          >
            {formSchema.buttonText}
          </Button>
        </>
      )}

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        // confirmBtn={`ยืนยัน${formSchema.buttonText}`}
        // cancleBtn={`ยกเลิก${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
